// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  convertDDtoDMSPref,
  convertDMStoDMSPref,
} from 'helpers/coordsConversion'

// returns formatted value or the
// input's value if formatting fails
const formatCoordOnBlur = ({ target }, inputOnBlur) => {
  const val = target.value.trim()
  const targetName = target.getAttribute('name')
  const axis = targetName.split(/[\].]/g).pop()
  const formatted = convertDDtoDMSPref(val, axis) || convertDMStoDMSPref(val, axis)
  return inputOnBlur(formatted || val)
}

export default formatCoordOnBlur
